export type SwallowAccessTokenOptions = {
  matchesPath: (pathname: string) => boolean;
  storageKey: (pathname: string) => string;
  keepOtherSearchParams: boolean;
};

export function swallowAccessTokenFromUrl(options: SwallowAccessTokenOptions): void {
  if (typeof window === 'undefined') {
    return;
  }
  const { pathname, search, hash } = window.location;
  if (!options.matchesPath(pathname)) {
    return;
  }
  const params = new URLSearchParams(search);
  const hasToken = params.has('token');
  if (hasToken) {
    const token = params.get('token');
    const key = options.storageKey(pathname);
    if (token) {
      sessionStorage.setItem(key, token);
    } else {
      sessionStorage.removeItem(key);
    }
    params.delete('token');
  }
  if (options.keepOtherSearchParams) {
    if (!hasToken) {
      return;
    }
    const nextSearch = params.toString();
    window.history.replaceState(
      window.history.state,
      document.title,
      `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash}`,
    );
    return;
  }
  if (search) {
    window.history.replaceState(window.history.state, document.title, `${pathname}${hash}`);
  }
}
